type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config) {
  if (!("serviceWorker" in navigator)) return;

  // Dev modda CRA service-worker.js üretmez → 404/bozuk kayıt oluşur. Sadece production build'de kaydet.
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", async () => {
    try {
      const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`.replace(/\/+/g, "/");
      const registration = await navigator.serviceWorker.register(swUrl);

      // İlk kurulumda controller genelde yoktur.
      if (!navigator.serviceWorker.controller) {
        config?.onSuccess?.(registration);
      }

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              config?.onUpdate?.(registration);
            } else {
              config?.onSuccess?.(registration);
            }
          }
        };
      };
    } catch (e) {
      console.error("[SW] registration failed", e);
    }
  });
}

export function unregister() {
  if (!("serviceWorker" in navigator)) return;

  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
}
